export const ncme = {
  /**
   * #
   */
  ncme: "ncme_liveCenter",
  ncme_liveCenter: "ncme_liveCenter",
  ncme_lecturerManage: "ncme_lecturerManage",
  ncme_lecturerManage_export: "ncme_lecturerManage_export",
  ncme_lecturerManage_add: "ncme_lecturerManage_add",
  ncme_lecturerManage_view: "ncme_lecturerManage_view",
  ncme_lecturerManage_edit: "ncme_lecturerManage_edit",
  ncme_lecturerManage_delete: "ncme_lecturerManage_delete",
  ncme_liveCenter_add: "ncme_liveCenter_add",
  ncme_liveCenter_export: "ncme_liveCenter_export",
  ncme_liveCenter_recommend: "ncme_liveCenter_recommend",
  ncme_liveCenter_online: "ncme_liveCenter_online",
  ncme_liveCenter_edit: "ncme_liveCenter_edit",
  ncme_liveCenter_delete: "ncme_liveCenter_delete",
  ncme_liveCenter_link: "ncme_liveCenter_link",
  ncme_liveCenter_trans: "ncme_liveCenter_trans",
  ncme_liveCenter_view: "ncme_liveCenter_view",
  ncme_liveCenter_multiLiveData: "ncme_liveCenter_multiLiveData",
  ncme_courseCenter_courseManage: "ncme_courseCenter_courseManage",
  ncme_courseCenter_courseManage_export: "ncme_courseCenter_courseManage_export",
  ncme_courseCenter_courseManage_add: "ncme_courseCenter_courseManage_add",
  ncme_courseCenter_courseManage_recommend: "ncme_courseCenter_courseManage_recommend",
  ncme_courseCenter_courseManage_online: "ncme_courseCenter_courseManage_online",
  ncme_courseCenter_courseManage_view: "ncme_courseCenter_courseManage_view",
  ncme_courseCenter_courseManage_copy: "ncme_courseCenter_courseManage_copy",
  ncme_courseCenter_courseManage_delete: "ncme_courseCenter_courseManage_delete",
  ncme_courseCenter_courseManage_edit: "ncme_courseCenter_courseManage_edit",
  ncme_courseCenter_seriesCourseManage: "ncme_courseCenter_seriesCourseManage",
  ncme_courseCenter_seriesCourseManage_export: "ncme_courseCenter_seriesCourseManage_export",
  ncme_courseCenter_seriesCourseManage_add: "ncme_courseCenter_seriesCourseManage_add",
  ncme_courseCenter_seriesCourseManage_recommend: "ncme_courseCenter_seriesCourseManage_recommend",
  ncme_courseCenter_seriesCourseManage_online: "ncme_courseCenter_seriesCourseManage_online",
  ncme_courseCenter_seriesCourseManage_view: "ncme_courseCenter_seriesCourseManage_view",
  ncme_courseCenter_seriesCourseManage_copy: "ncme_courseCenter_seriesCourseManage_copy",
  ncme_courseCenter_seriesCourseManage_delete: "ncme_courseCenter_seriesCourseManage_delete",
  ncme_courseCenter_seriesCourseManage_edit: "ncme_courseCenter_seriesCourseManage_edit",
  ncme_contentManage_articleManage: "ncme_contentManage_articleManage",
  ncme_contentManage_articleManage_export: "ncme_contentManage_articleManage_export",
  ncme_contentManage_articleManage_edit: "ncme_contentManage_articleManage_edit",
  ncme_contentManage_articleManage_add: "ncme_contentManage_articleManage_add",
  ncme_contentManage_articleManage_groupOnline: "ncme_contentManage_articleManage_groupOnline",
  ncme_contentManage_articleManage_groupDelete: "ncme_contentManage_articleManage_groupDelete",
  ncme_contentManage_articleManage_recommend: "ncme_contentManage_articleManage_recommend",
  ncme_contentManage_articleManage_comment: "ncme_contentManage_articleManage_comment",
  ncme_contentManage_articleManage_online: "ncme_contentManage_articleManage_online",
  ncme_contentManage_articleManage_cancelOnTimeOnline: "ncme_contentManage_articleManage_cancelOnTimeOnline",
  ncme_contentManage_articleManage_delete: "ncme_contentManage_articleManage_delete",
  ncme_academic_tasks: "ncme_academic_tasks",
  ncme_academic_tasks_add: "ncme_academic_tasks_add",
  ncme_academic_tasks_export: "ncme_academic_tasks_export",
  ncme_academic_tasks_finish: "ncme_academic_tasks_finish",
  ncme_academic_tasks_link: "ncme_academic_tasks_link",
  ncme_academic_tasks_edit: "ncme_academic_tasks_edit",
  ncme_academic_tasks_detail_export: "ncme_academic_tasks_detail_export",
  ncme_academic_tasks_detail: "ncme_academic_tasks_detail",
  ncme_special_area: "ncme_special_area",
  ncme_special_area_add: "ncme_special_area_add",
  ncme_special_area_edit: "ncme_special_area_edit",
  ncme_special_area_online_offline: "ncme_special_area_online_offline",
  ncme_special_area_visit: "ncme_special_area_visit",
  ncme_special_area_set_home_page: "ncme_special_area_set_home_page",
  ncme_access_setting: "ncme_access_setting",
  ncme_access_code_add: "ncme_access_code_add",
  ncme_access_code_copy: "ncme_access_code_copy",
  ncme_access_code_invalid: "ncme_access_code_invalid",
  ncme_questionnaire: "ncme_questionnaire",
  ncme_questionnaire_add: "ncme_questionnaire_add",
  ncme_questionnaire_export: "ncme_questionnaire_export",
  ncme_questionnaire_edit_button: "ncme_questionnaire_edit_button",
  ncme_questionnaire_online_offline: "ncme_questionnaire_online_offline",
  ncme_questionnaire_share: "ncme_questionnaire_share",
  ncme_questionnaire_visit: "ncme_questionnaire_visit",
  ncme_questionnaire_data: "ncme_questionnaire_data",
  ncme_questionnaire_copy: "ncme_questionnaire_copy",
  ncme_questionnaire_delete: "ncme_questionnaire_delete",
  ncme_questionnaire_answerSheetPage: "ncme_questionnaire_answerSheetPage",
  ncme_questionnaire_answerSheetDetail: "ncme_questionnaire_answerSheetDetail",
  ncme_questionnaire_edit: "ncme_questionnaire_edit",
  ncme_active_center: "ncme_active_center",
  ncme_active_center_manage: "ncme_active_center_manage",
  ncme_active_center_manage_detail: "ncme_active_center_manage_detail",
  ncme_active_center_manage_edit: "ncme_active_center_manage_edit",
  ncme_active_center_manage_copy: "ncme_active_center_manage_copy",
  ncme_active_center_manage_collection: "ncme_active_center_manage_collection",
  ncme_active_center_manage_activity_end: "ncme_active_center_manage_activity_end",
  ncme_active_center_manage_activity_link: "ncme_active_center_manage_activity_link",
  ncme_active_center_detail: "ncme_active_center_detail",
  ncme_active_center_detail_contribute: "ncme_active_center_detail_contribute",
  ncme_active_center_detail_contribute_for_screening: "ncme_active_center_detail_contribute_for_screening",
  ncme_active_center_detail_contribute_adopted: "ncme_active_center_detail_contribute_adopted",
  ncme_active_center_detail_contribute_decline: "ncme_active_center_detail_contribute_decline",
  ncme_active_center_detail_contribute_batch_adopted: "ncme_active_center_detail_contribute_batch_adopted",
  ncme_active_center_detail_contribute_adopted_button: "ncme_active_center_detail_contribute_adopted_button",
  ncme_active_center_detail_contribute_batch_reject: "ncme_active_center_detail_contribute_batch_reject",
  ncme_active_center_detail_contribute_reject_button: "ncme_active_center_detail_contribute_reject_button",
  ncme_active_center_detail_contribute_for_screening_export: "ncme_active_center_detail_contribute_for_screening_export",
  ncme_active_center_detail_contribute_adopted_export: "ncme_active_center_detail_contribute_adopted_export",
  ncme_active_center_detail_contribute_decline_export: "ncme_active_center_detail_contribute_decline_export",
  ncme_active_center_detail_contribute_decline_del: "ncme_active_center_detail_contribute_decline_del",
  ncme_active_center_detail_contribute_decline_withdraw: "ncme_active_center_detail_contribute_decline_withdraw",
  ncme_active_center_detail_contribute_adopted_paymentReward: "ncme_active_center_detail_contribute_adopted_paymentReward",
  ncme_active_center_detail_contribute_adopted_batch_paymentReward: "ncme_active_center_detail_contribute_adopted_batch_paymentReward",
  ncme_active_center_detail_contribute_adopted_transmissionReward: "ncme_active_center_detail_contribute_adopted_transmissionReward",
  ncme_active_center_detail_contribute_adopted_batch_transmissionReward: "ncme_active_center_detail_contribute_adopted_batch_transmissionReward",
  ncme_message_center: "ncme_message_center",
  ncme_message_center_health: "ncme_message_center_health",
  ncme_message_center_doctor: "ncme_message_center_doctor",
  ncme_message_center_push: "ncme_message_center_push",
  ncme_message_center_push_health: "ncme_message_center_push_health",
  ncme_message_center_push_doctor: "ncme_message_center_push_doctor",
  ncme_message_center_push_add: "ncme_message_center_push_add",
  ncme_message_center_push_export: "ncme_message_center_push_export",
  ncme_message_center_push_edit: "ncme_message_center_push_edit",
  ncme_message_center_push_detail: "ncme_message_center_push_detail",
  ncme_message_center_push_cancel: "ncme_message_center_push_cancel",
  ncme_message_center_record: "ncme_message_center_record",
  ncme_message_center_record_health: "ncme_message_center_record_health",
  ncme_message_center_record_doctor: "ncme_message_center_record_doctor",
  ncme_message_center_record_export: "ncme_message_center_record_export",
  ncme_dataBoard: "ncme_dataBoard",
  ncme_dataBoard_dataOverView: "ncme_dataBoard_dataOverView",
  ncme_dataBoard_doctorOverView: "ncme_dataBoard_doctorOverView",
  ncme_dataBoard_doctorOverView_show: "ncme_dataBoard_doctorOverView_show",
  ncme_dataBoard_contentOverView: "ncme_dataBoard_contentOverView",
  ncme_dataBoard_campaignOverView: "ncme_dataBoard_campaignOverView",
  ncme_dataBoard_progress_details: "ncme_dataBoard_progress_details",
  ncme_content_collection: "ncme_content_collection",
  ncme_article_collection: "ncme_article_collection",
  ncme_article_collection_export: "ncme_article_collection_export",
  ncme_article_collection_adopt: "ncme_article_collection_adopt",
  ncme_article_collection_reject: "ncme_article_collection_reject",
  ncme_article_collection_delete: "ncme_article_collection_delete",
  ncme_article_collection_registry_collector_list: "ncme_article_collection_registry_collector_list",
  ncme_article_collection_collected_list: "ncme_article_collection_collected_list",
  ncme_article_collection_registry_reject_list: "ncme_article_collection_registry_reject_list",
  ncme_renovation_manage: "ncme_renovation_manage",
  ncme_renovation_manage_home_page_edit: "ncme_renovation_manage_home_page_edit",
  ncme_renovation_manage_home_page_visit: "ncme_renovation_manage_home_page_visit",
  ncme_renovation_manage_home_page_online_or_offline: "ncme_renovation_manage_home_page_online_or_offline",
  ncme_global_controller: "ncme_global_controller",
  ncme_community_info: "ncme_community_info",
  ncme_community_info_edit: "ncme_community_info_edit",
  ncme_channelManage_channelListManage: "ncme_channelManage_channelListManage",
  ncme_channelManage_channelList: "ncme_channelManage_channelList",
  ncme_channelManage_channelList_add: "ncme_channelManage_channelList_add",
  ncme_channelManage_channelList_edit: "ncme_channelManage_channelList_edit",
  ncme_channelManage_secondChannelList: "ncme_channelManage_secondChannelList",
  ncme_channelManage_secondChannelList_add: "ncme_channelManage_secondChannelList_add",
  ncme_channelManage_secondChannelList_edit: "ncme_channelManage_secondChannelList_edit",
  ncme_channelManage_channelLinkList: "ncme_channelManage_channelLinkList",
  ncme_channelManage_channelLinkList_add: "ncme_channelManage_channelLinkList_add",
  ncme_channelManage_channelLinkList_copy: "ncme_channelManage_channelLinkList_copy",
  ncme_channelManage_addChannelLink: "ncme_channelManage_addChannelLink"
};